var __hasOwnProp = Object.prototype.hasOwnProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __assign = Object.assign;
var __rest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/index.tsx
import {
  createElement,
  forwardRef
} from "react";
import {
  node
} from "prop-types";
import {Box} from "@twilio-paste/box";
var ScreenReaderOnly = forwardRef((_a, ref) => {
  var {as = "span", children} = _a, props = __rest(_a, ["as", "children"]);
  return /* @__PURE__ */ createElement(Box, __assign(__assign({}, props), {
    as,
    border: "none",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "spaceNegative10",
    overflow: "hidden",
    padding: "space0",
    position: "absolute",
    ref,
    textTransform: "none",
    whiteSpace: "nowrap",
    width: "1px"
  }), children);
});
ScreenReaderOnly.displayName = "ScreenReaderOnly";
if (true) {
  ScreenReaderOnly.propTypes = {
    children: node.isRequired
  };
}
export {
  ScreenReaderOnly
};
